import { TFieldConfig } from "../types/common";

export const otpFields: TFieldConfig[] = [
  {
    field_name: "otp",
    type: "otp-pin-input",
    label: "otp",
    props: {
      required: true,
      wide: true,
      length: 6,
    },
  },
];
